import {useEffect} from 'react';
import {$getSelection, $isRangeSelection, $isTextNode} from 'lexical';
import {$getNearestNodeOfType, mergeRegister} from '@lexical/utils';
import {$getSelectionStyleValueForProperty} from '@lexical/selection';
import {IUseCustomToolbarPlugin} from './types';
import {useEmailContext} from '../../../../context';
import {$isListNode, ListNode} from '@lexical/list';
import {EFormatText} from '../ToolbarPlugin/enums';
import {FONT_SIZE} from '../../constants';

export const useCustomToolbarPlugin = ({
    editor,
    setFontFormat,
    setBlockType
}: IUseCustomToolbarPlugin) => {
    const {
        states: {hyperlinkState},
        handlers: {updateHyperlinkStates}
    } = useEmailContext();

    const updateToolbarPlugins = () => {
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
            selection.getNodes().forEach(node => {
                if ($isTextNode(node)) {
                    if (
                        selection.focus.offset !== selection.anchor.offset &&
                        hyperlinkState?.active
                    ) {
                        updateHyperlinkStates({
                            ...hyperlinkState,
                            text: selection.getTextContent()
                        });
                    }

                    const anchorNode = selection.anchor.getNode();
                    const element =
                        anchorNode.getKey() === 'root'
                            ? anchorNode
                            : anchorNode.getTopLevelElementOrThrow();
                    const elementKey = element.getKey();
                    const elementDOM = editor.getElementByKey(elementKey);
                    if (elementDOM !== null) {
                        if ($isListNode(element)) {
                            const parentList = $getNearestNodeOfType(anchorNode, ListNode);
                            const type = parentList ? parentList.getTag() : element.getTag();
                            setBlockType(type);
                        } else {
                            const type = element.getType();
                            setBlockType(type);
                        }
                    }

                    setFontFormat({
                        fontSize: $getSelectionStyleValueForProperty(selection, FONT_SIZE, '14px'),
                        isBold: selection.hasFormat(EFormatText.BOLD),
                        isItalic: selection.hasFormat(EFormatText.ITALIC),
                        isUnderline: selection.hasFormat(EFormatText.UNDERLINE),
                        isStrikethrough: selection.hasFormat(EFormatText.STRIKETHROUGH)
                    });
                }
            });
        }
    };

    useEffect(() => {
        return mergeRegister(
            editor.registerUpdateListener(({editorState}) => {
                editorState.read(() => {
                    updateToolbarPlugins();
                });
            })
        );
    }, [editor, updateToolbarPlugins]);
};
